.readout {
  display: grid;
  gap: var(--space-1);
}

.caption {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-family: var(--font-display);
  font-size: var(--text-2xs);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
  color: var(--ink-muted);
}

/* The one place the sprout's lime is spent. It is a 6px pip, which is all the
   area a 15.5:1 colour can occupy without shouting down the nav beside it. */
.pipLive,
.pipIdle {
  flex: none;
  width: 6px;
  height: 6px;
  border-radius: var(--radius-pill);
}

.pipLive {
  background: var(--leaf);
  /* Live state is carried by the glow as well as the hue, so it still reads
     as distinct from idle in greyscale (spec 13). */
  box-shadow: 0 0 0 3px var(--leaf-wash);
}

.pipIdle {
  background: none;
  border: 1px solid var(--line-strong);
}

.counts {
  font-family: var(--font-display);
  font-size: var(--text-xs);
  color: var(--ink-secondary);
}

.figure {
  color: var(--ink-primary);
  font-size: var(--text-md);
  font-weight: 600;
  letter-spacing: 0;
}

.divider {
  padding: 0 var(--space-2);
  color: var(--line-strong);
}
